import { render } from "./TargetAreaManager.vue?vue&type=template&id=4fce7db6"
import script from "./TargetAreaManager.vue?vue&type=script&lang=js"
export * from "./TargetAreaManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__